import React, { useEffect, useMemo, useRef, useState } from "react";

import {
  Button,
  Typography,
  TextField,
  Box,
  Paper,
  Grid,
  Link,
} from "@material-ui/core";

import {
  LocalHospital,
  Flight,
  ShoppingCart,
  School,
  Home,
  BusinessCenter,
} from "@material-ui/icons";
import brandTheme from "brandTheme/Theme";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import {
  welcomeFeatures,
  welcomeEligibilityList,
  welcomeOtherFeesCharges,
  welcomePurposeList,
} from "assets/properties/properties";

import { FeatureCard, DetailListCard } from "./WelcomeComponents";
import { welcomeWhyChooseUS } from "assets/properties/properties";
import ApplicationRequirements from "./ApplicationRequirements";
import FeatureEligibilityCard from "./FeatureAndEligible";
import { DocumentGrid } from "./DocumentRequired";
import { documentItems } from "assets/properties/properties";
import HowItWorksSection from "./HowItWorksSection";
import {
  Security,
  Description,
  ContactSupport,
} from "@material-ui/icons";
import shield from "../../../assets/img/zeroChargesShield.png"
import piggyBank from "../../../assets/img/piggiImageWithShield.png"
import LoanAtAGlance from "./LoanAtGlance";
import { getDeviceType } from "utils/Utils";
import { enableGetTheAppButton } from "assets/properties/properties";
const useStyles = makeStyles((theme) => ({
  "@keyframes fadeInUp": {
    "0%": {
      opacity: 0,
      transform: "translateY(30px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  "@keyframes slideInLeft": {
    "0%": {
      opacity: 0,
      transform: "translateX(-40px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)",
    },
  },

  "@keyframes slideInRight": {
    "0%": {
      opacity: 0,
      transform: "translateX(40px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)",
    },
  },

  "@keyframes softFloat": {
    "0%, 100%": {
      transform: "translateY(0)",
    },
    "50%": {
      transform: "translateY(-10px)",
    },
  },

  // "@keyframes glow": {
  //   "0%, 100%": {
  //     boxShadow:
  //       "0 15px 45px rgba(61, 10, 28, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
  //   },
  //   "50%": {
  //     boxShadow:
  //       "0 15px 45px rgba(61, 10, 28, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
  //   },
  // },

  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.7,
    },
  },

  container: {
    minHeight: "100vh",
    scrollBehavior: "smooth",
    position: "relative",
    background: "linear-gradient(180deg, #FFFFFF 0%, #F5F8FF 100%)",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },

  heroSection: {
  minHeight: 500,
  height: "auto",
  backgroundImage: 'url("/images/welcome.webp")',
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  padding: theme.spacing(9, 8),
  color: "#fff",
  marginBottom: theme.spacing(7),

  position: "relative",
  overflow: "hidden",

  // Fade ONLY the background image
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    // background: "rgba(255, 255, 255, 0.55)",
    zIndex: 0,
  },

  [theme.breakpoints.down(900)]: {
    backgroundImage: 'url("/images/mobileWelcome.webp")',

    // width: "100%",
    // minHeight: "560px",
    padding: "50px 20px",

    // More fade on mobile
    "&::before": {
      background: "rgba(255, 255, 255, 0.84)",
    },
  },

  // [theme.breakpoints.down(600)]: {
  //   // minHeight: "570px",
  //   padding: "20px 16px",
  // },
},
  nbfcTitle: {
  position: "relative",
  zIndex: 1,

  color: brandTheme.black,
  fontSize: 12,
  background: brandTheme.white,
  border: "1px solid gray",
  padding: "2px 10px",
  borderRadius: "20px",
  width: "fit-content",

  [theme.breakpoints.down("sm")]: {
    fontSize: 10,
    maxWidth: "100%",
    whiteSpace: "normal",
  },
},
heroText: {
  color: brandTheme.black,
},
 heroTitle: {
  position: "relative",
  zIndex: 1,

  paddingTop: "20px",
  fontWeight: 800,
  marginBottom: theme.spacing(3),

  animation: "$fadeInUp 1.2s ease-out both",

  fontSize: "50px",
  letterSpacing: "-1px",
  lineHeight: 1.2,

  color: brandTheme.black,
  display: "block",

  [theme.breakpoints.down("sm")]: {
    fontSize: "45px",
    lineHeight: 1.15,
    paddingTop: "15px",
    marginBottom: theme.spacing(2),
  },

  [theme.breakpoints.down(600)]: {
    fontSize: "40px",
  },
   [theme.breakpoints.down(500)]: {
    fontSize: "35px",
  },
   [theme.breakpoints.down(440)]: {
    fontSize: "30px",
  },
},

 heroSubtitle: {
  position: "relative",
  zIndex: 1,

  maxWidth: "700px",
  lineHeight: 2,
  marginBottom: theme.spacing(4),

  color: brandTheme.black,
  fontSize: "20px",
  fontWeight: 400,
  letterSpacing: "0.3px",

  width: "40%",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: "380px",
    // fontSize: "15px",
    lineHeight: 1.5,
    marginBottom: theme.spacing(3),
  },
  [theme.breakpoints.down(600)]: {
    fontSize: "17px",
  },
},

 heroButtons: {
  position: "relative",
  zIndex: 1,

  display: "flex",
  gap: theme.spacing(2),
  flexWrap: "wrap",

  [theme.breakpoints.down("sm")]: {
    gap: "10px",
  },
    [theme.breakpoints.down(471)]: {
      flexDirection:'column',
      // width:'95%'
    }
},
  primaryButton: {
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    padding: theme.spacing(2, 5),
    borderRadius: "12px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "16px",
    transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
    letterSpacing: "0.5px",
    position: "relative",
    overflow: "hidden",

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: "-100%",
      width: "100%",
      height: "100%",
      background: brandTheme.secondaryColor,
      transition: "left 0.4s ease",
    },

    "&:hover": {
      backgroundColor:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      transform: "translateY(-4px)",
      color: brandTheme.white,
      "&::before": {
        left: "100%",
      },
    },

    "&:active": {
      transform: "translateY(-2px)",
    },
    // [theme.breakpoints.down("sm")]: {
    //   width: "100%",
    // },
  },

  secondaryButton: {
    border: `2px solid ${brandTheme.secondaryColor}`,
    color: brandTheme.secondaryColor,
    padding: theme.spacing(1.8, 4.5),
    borderRadius: "12px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "16px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
    letterSpacing: "0.5px",

    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      transform: "translateY(-4px)",
      boxShadow: "0 20px 40px rgba(255, 255, 255, 0.2)",
    },

    "&:active": {
      transform: "translateY(-2px)",
    },
    // [theme.breakpoints.down("sm")]: {
    //   width: "100%",
    // },
  },

  section: {
    marginBottom: theme.spacing(7),
  },

  revealHidden: {
    opacity: 0,
    transform: "translateY(24px)",
    transition: "opacity 0.7s ease, transform 0.7s ease",
  },

  revealVisible: {
    opacity: 1,
    transform: "translateY(0)",
    transition: "opacity 0.7s ease, transform 0.7s ease",
  },
  subSectionTitle: {
    color: brandTheme.secondaryColor,
    fontWeight: 800,
    marginBottom: theme.spacing(1),
    margin: "0px 5px",
    position: "relative",
    fontSize: "50px",
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
    [theme.breakpoints.down("md")]: {
      fontSize: "36px",
    },
  },
  sectionTitle: {
    textAlign: "center",
    color: brandTheme.mainColor,
    fontWeight: 800,
    marginBottom: theme.spacing(1),
    position: "relative",
    fontSize: "44px",
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
    "&::after": {
      content: '""',
      display: "block",
      width: "80px",
      height: "6px",
      background: "linear-gradient(135deg, #15254F, #1E3D72)",
      borderRadius: "3px",
      margin: "16px auto 0",
      boxShadow: `0 4px 15px ${brandTheme.backgroundColor}`,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "36px",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: "28px",
    },
  },

  sectionSubtitle: {
    textAlign: "center",
    color: "#666",
    marginBottom: theme.spacing(4),
    fontSize: "24px",
    fontWeight: 700,
    letterSpacing: "0.2px",
    lineHeight: 1.6,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      marginBottom: theme.spacing(5),
    },
  },

  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },

  featureCard: {
    background: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(10px)",
    padding: theme.spacing(5),
    borderRadius: "24px",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    boxShadow:
      "0 15px 45px rgba(21, 37, 79, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
    transition: "all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)",
    cursor: "pointer",
    animation: "$fadeInUp 1s ease-out both",
    position: "relative",
    overflow: "hidden",

    "&::before": {
      content: '""',
      position: "absolute",
      top: "-50%",
      right: "-50%",
      width: "100%",
      height: "100%",
      opacity: 0,
      transition: "opacity 0.5s ease",
    },

    "&:hover": {
      transform: "translateY(-12px) scale(1.02)",
      boxShadow:
        "0 25px 60px rgba(21, 37, 79, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
      "&::before": {
        opacity: 1,
      },
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
      borderRadius: "20px",
    },
  },

  cardHeading: {
    fontWeight: 700,
    color: brandTheme.mainColor,
    marginBottom: theme.spacing(2),
    fontSize: "20px",
    letterSpacing: "-0.2px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },

  requirementsCard: {
    background: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
    borderRadius: "28px",
    padding: theme.spacing(8),
    boxShadow:
      "0 15px 50px rgba(61, 10, 28, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    animation: "$fadeInUp 1.2s ease-out both",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },

  row: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))",
    gap: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },

  requirementItem: {
    fontSize: 20,
    lineHeight: 1.8,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },

  detailItem: {
    marginBottom: theme.spacing(3),
  },

  detailItemTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    color: brandTheme.mainColor,
  },

  detailItemText: {
    color: brandTheme.mainColor,
  },

  verifyCard: {
    background: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
    borderRadius: "28px",
    overflow: "hidden",
    boxShadow:
      "0 20px 60px rgba(61, 10, 28, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    animation: "$fadeInUp 1.2s ease-out both",
  },

  verifyHeader: {
    background: "linear-gradient(135deg, #15254F, #1E3D72)",
    padding: "32px",
    fontSize: "20px",
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      padding: "24px",
    },
  },

  verifyBody: {
    padding: "35px",
    background: "#fff",
    animation: "$fadeInUp 0.8s ease-out both",
    [theme.breakpoints.down("sm")]: {
      padding: "24px",
    },
  },

  verifyItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "20px",
    marginBottom: "35px",
    transition: "transform 0.3s ease",

    "&:hover": {
      transform: "translateX(4px)",
    },

    [theme.breakpoints.down("sm")]: {
      gap: "14px",
      marginBottom: "24px",
    },
  },

  verifyText: {
    color: brandTheme.mainColor,
    margin: "auto 0",
    fontSize: 18,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  cardImage: {
    width: "100%",
    aspectRatio: "5/7",
  },
  cardBody: {
    display: "flex",
    background: brandTheme.white,
    padding: "20px 20px 0px",
    justifyContent: "space-between",
    boxShadow: `0 20px 40px brandTheme.secondaryColor`,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
    },
  },
  cardHeader: {
    borderRadius: "20px 20px 0px 0px",
    padding: "15px 0px 15px 20px",
  },
  listItem: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
    paddingBottom: "15px",
  },
  imageWrapper: {
    width: "30%",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  numberCircle: {
    width: "25px",
    height: "25px",
    minWidth: "25px",
    borderRadius: "50%",
    border: `3px solid ${brandTheme.secondaryColor}`,
    color: brandTheme.secondaryColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: "12px",
    background: "#fff",
    boxShadow: `0 2px 5px ${brandTheme.mainColor}`,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "46px",
      height: "46px",
      minWidth: "46px",
      fontSize: "15px",
    },
  },

  calculatorBox: {
    background: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
    borderRadius: "32px",
    padding: theme.spacing(8),
    boxShadow:
      "0 20px 60px rgba(61, 10, 28, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
    animation: "$fadeInUp 1.2s ease-out both",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(6),
    },

    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
      borderRadius: "24px",
    },
  },

  calculatorResult: {
    backgroundImage: 'url("/images/newCalculator.webp")',
    backgroundSize: "100% 100%",
    // background:
    //   "linear-gradient(135deg, #15254F, #001F54)",
    color: brandTheme.mainColor,
    padding: theme.spacing(6),
    borderRadius: "24px",
    animation: "$softFloat 5s ease-in-out infinite",
    boxShadow: "0 20px 50px rgba(61, 10, 28, 0.3)",
    fontSize: "32px",
    fontWeight: 700,
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(5),
    },

    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
      borderRadius: "20px",
      fontSize: "24px",
    },
  },

  purposeGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
    gap: "25px",
    marginTop: "40px",
    background: "rgba(255, 255, 255, 0.85)",
    boxShadow:
      "0 15px 45px rgba(61, 10, 28, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
    borderRadius: "15px",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      gap: "16px",
      marginTop: "28px",
    },

    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr 1fr",
    },
  },

  purposeCard: {
    // background: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(10px)",
    borderRadius: "28px",
    padding: "40px 25px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    // boxShadow:
    //   "0 15px 45px rgba(61, 10, 28, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
    transition: "all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)",
    cursor: "pointer",
    animation: "$fadeInUp 1s ease-out both",
    // border: "1px solid rgba(255, 255, 255, 0.6)",
    position: "relative",

    "&:hover": {
      transform: "translateY(-15px) scale(1.05)",
      boxShadow:
        "0 25px 60px rgba(61, 10, 28, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
      borderColor: "rgba(161, 35, 75, 0.4)",
    },
    [theme.breakpoints.down("md")]: {
      padding: "32px 22px",
    },

    [theme.breakpoints.down("sm")]: {
      padding: "26px 18px",
      borderRadius: "22px",

      "&:hover": {
        transform: "translateY(-8px) scale(1.02)",
      },
    },
  },

  purposeIcon: {
    width: "90px",
    height: "90px",
    borderRadius: "50%",
    background: brandTheme.backgroundColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: brandTheme.secondaryColor,
    marginBottom: "24px",
    animation: "$softFloat 6s ease-in-out infinite",
    // boxShadow: "0 15px 40px rgba(61, 10, 28, 0.25)",

    "& svg": {
      fontSize: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "72px",
      height: "72px",
      marginBottom: "18px",

      "& svg": {
        fontSize: "32px",
      },
    },
  },

  smallIcon: {
    width: 54,
    height: 54,
    borderRadius: "50%",
    background: brandTheme.backgroundColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& svg": {
      fontSize: 30,
      fill: brandTheme.secondaryColor,
    },
    [theme.breakpoints.down("sm")]: {
      width: 42,
      height: 42,

      "& svg": {
        fontSize: 20,
      },
    },
  },

  featureIcon: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    background: brandTheme.backgroundColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: brandTheme.secondaryColor,
    boxShadow: `0 2px 8px ${brandTheme.shaddowColor}`,

    "& svg": {
      fontSize: 50,
      fill: brandTheme.secondaryColor,
    },
    [theme.breakpoints.down("md")]: {
      width: 84,
      height: 84,

      "& svg": {
        fontSize: 44,
      },
    },

    [theme.breakpoints.down("sm")]: {
      width: 72,
      height: 72,

      "& svg": {
        fontSize: 36,
      },
    },
  },

  purposeTitle: {
    fontWeight: 700,
    color: brandTheme.mainColor,
    fontSize: "18px",
    textAlign: "center",
    letterSpacing: "-0.2px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },

  footer: {
    background: "linear-gradient(135deg, #15254F, #1E3D72)",
    color: "#fff",
    padding: theme.spacing(8),
    borderRadius: "32px",
    marginTop: theme.spacing(12),
    marginBottom: theme.spacing(12),
    textAlign: "center",
    boxShadow:
      "0 30px 100px rgba(61, 10, 28, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    fontSize: "18px",
    fontWeight: 500,
    letterSpacing: "0.2px",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(6),
    },

    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
      borderRadius: "24px",
      marginTop: theme.spacing(8),
      fontSize: "16px",
    },
  },
  // styles
  requirementRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 8,

    "& svg": {
      fill: brandTheme.secondaryColor,
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
      gap: 6,
    },
  },
  helpSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "linear-gradient(135deg, #1CB167 0%, #1CB167 50%, #020b5c 100%)",
    borderRadius: 16,
    padding: "16px 32px",
    marginTop: 40,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      textAlign: "center",
      gap: 16,
      padding: 20,
    },
  },

  helpImage: {
    width: "22%",
    height: "auto",
    flexShrink: 0,
    position: "absolute",
    bottom: "3%",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  helpContent: {
    flex: 1,
    padding: "0 24px",
    marginLeft: "22%",
    [theme.breakpoints.down("md")]: {
      margin: 0,
    },
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },

  helpTitle: {
    color: "#fff",
    fontWeight: 700,
    marginBottom: 8,
  },
  featureContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(450px,1fr))",
    gap: 24,
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },

  howItWorkSection: {
    // boxShadow:
    //   "0 15px 45px rgba(61, 10, 28, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
  },
  helpDescription: {
    color: "rgba(255,255,255,0.85)",
  },

  applyButton: {
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    fontWeight: 700,
    borderRadius: 8,
    padding: "12px 28px",
    textTransform: "none",

    "&:hover": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    },
  },
  slider: {
    width: "100%",
    cursor: "pointer",
    appearance: "none",
    background: "transparent",

    "&::-webkit-slider-runnable-track": {
      height: "8px",
      borderRadius: "999px",
      background: "linear-gradient(90deg, #1CB167, #1E3D72)",
    },
    "&::-webkit-slider-thumb": {
      appearance: "none",
      width: "20px",
      height: "20px",
      borderRadius: "50%",
      background: "#fff",
      border: `3px solid ${brandTheme.mainColor}`,
      marginTop: "-6px",
      // boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
      transition: "0.3s",

      "&:hover": {
        transform: "scale(1.1)",
      },
    },

    "&::-moz-range-track": {
      height: "8px",
      borderRadius: "999px",
      background: "linear-gradient(90Deg, #15254F, #1E3D72)",
    },
    "&::-moz-range-thumb": {
      width: "20px",
      height: "20px",
      borderRadius: "50%",
      background: "#fff",
      border: `3px solid ${brandTheme.mainColor}`,
      cursor: "pointer",
    },
    [theme.breakpoints.down("sm")]: {
      "&::-webkit-slider-runnable-track": {
        height: "6px",
      },

      "&::-webkit-slider-thumb": {
        width: "18px",
        height: "18px",
        marginTop: "-6px",
      },

      "&::-moz-range-track": {
        height: "6px",
      },

      "&::-moz-range-thumb": {
        width: "18px",
        height: "18px",
      },
    },
  },
  zeroForeclosureBanner: {
    width: "100%",
    margin: "24px 0",
    padding: "0 28px",
    height: 'auto',
    borderRadius: 18,
    border: "2px solid #28C76F",
    background:
      "linear-gradient(90deg,#F8FFF9 0%,#FFFFFF 45%,#F8FFF9 100%)",
    boxSizing: "border-box",
    
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      padding: 16,
    },
  },
  
  foreClosureContainer: {
    display: "grid",
    gridTemplateColumns: "170px 1fr 170px",
    alignItems: "center",
    height: "100%",
  
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      textAlign: "center",
      rowGap: 10,
    },
  },
  
  leftIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  
  shieldImage: {
    width: 80,
    height: 50,
    zoom:3,
    [theme.breakpoints.down("sm")]: {
      display:"none"
    },
  },
  
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign:'center'
  },
    "@keyframes blink": {
    "0%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.1,
    },
    "100%": {
      opacity: 1,
    },
  },
  
  title: {
    fontSize: 34,
    fontWeight: 700,
    color: "#1C2E73",
    marginBottom: 6,
    animation: "$blink 1s linear infinite",
    [theme.breakpoints.down("sm")]: {
      fontSize: 27,
    },
  },
  

  
  description: {
    fontSize: 20,
    color: "#2F4056",
    lineHeight: "28px",
    fontWeight: 500,
  
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
      lineHeight: "22px",
    },
  },
  
  rightIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  
  piggyImage: {
    width: 80,
    height: 50,
    zoom:3,
    [theme.breakpoints.down("sm")]: {
      display:"none"
    },
  },
  legalContainer: {
  marginTop: 40,
  marginBottom: 40,
  padding: "28px 24px",
  borderRadius: 22,
  background: "#fff",
  // boxShadow: "0 12px 40px rgba(0,0,0,.08)",

  [theme.breakpoints.down("md")]: {
    padding: "22px 18px",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "16px",
    borderRadius: 16,
    marginTop: 24,
    marginBottom: 24,
  },
},

  legalTitle: {
    fontSize: 34,
    fontWeight: 700,
    color: "#0B2E73",
    textAlign: "center",
  },

  legalSubtitle: {
    marginTop: 8,
    color: "#777",
    textAlign: "center",
    fontSize: 16,
  },

  legalCard: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  minHeight: 80,
  padding: "18px 16px",
  borderRight: "2px solid #E6EEF8",
  transition: ".3s",

  "&:hover": {
    transform: "translateY(-5px)",
    // boxShadow: "0 12px 30px rgba(0,0,0,.08)",
    background: "#fff",
  },

  [theme.breakpoints.down("sm")]: {
    borderRight: "none",
    borderBottom: "1px solid #E6EEF8",
    justifyContent: "flex-start",
    padding: "16px 12px",
    minHeight: "auto",
  },
},

  iconCircle: {
  width: 50,
  height: 50,
  minWidth: 50,
  borderRadius: "50%",
  background: "#EAFBF2",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "& svg": {
    fontSize: 30,
    color: "#1CB167",
  },

  [theme.breakpoints.down("sm")]: {
    width: 42,
    height: 42,
    minWidth: 42,

    "& svg": {
      fontSize: 24,
    },
  },
},

  linkTitle: {
  color: "#0B2E73",
  fontWeight: 700,
  fontSize: 16,
  textAlign: "left",

  [theme.breakpoints.down("sm")]: {
    fontSize: 15,
  },
},
appDownloadButtons: {
  display: "flex",
  gap: "12px",
  marginTop: "20px",
  flexWrap: "wrap",

  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
    gap: "10px",
  },
},

appStoreButton: {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "10px 16px",
  borderRadius: "10px",
  background: "#fff",
  color: "#15254F",
  textDecoration: "none",
  fontWeight: 700,
  fontSize: "13px",
  transition: "all 0.3s ease",

  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
    textDecoration: "none",
  },
},

appStoreIcon: {
  fontSize: "22px",
  fontWeight: 700,
},

appStoreText: {
  display: "flex",
  flexDirection: "column",
  lineHeight: 1.1,
},

appStoreSmallText: {
  fontSize: "9px",
  fontWeight: 400,
},

appStoreMainText: {
  fontSize: "14px",
  fontWeight: 700,
},
mobileAppBanner: {
  position: "fixed",
  bottom: 2,
  left: "50%",
  transform: "translateX(-50%)",
  width: "calc(100% - 40px)",
  maxWidth: "1000px",
  zIndex: 9999,

  display: "none",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 20,

  padding: "16px 24px",
  borderRadius: 18,

  background:
    "linear-gradient(135deg, #032B73 0%, #001F5B 60%, #0B347D 100%)",

  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
  border: "1px solid rgba(255,255,255,0.15)",

  animation: "$fadeInUp 0.5s ease-out",

  [theme.breakpoints.down("sm")]: {
    width: "calc(100% - 20px)",
    bottom: 10,
    padding: "14px 14px",
    borderRadius: 14,
    gap: 10,
    flexDirection: "column",
    alignItems: "stretch",
  },
},

mobileAppBannerContent: {
  display: "flex",
  alignItems: "center",
  gap: 14,
  flex: 1,

  [theme.breakpoints.down("sm")]: {
    paddingRight: 25,
  },
},

mobileAppBannerIcon: {
  width: 48,
  height: 48,
  minWidth: 48,
  borderRadius: 12,
  background: "#fff",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  fontSize: 25,
  fontWeight: 800,
  color: "#1CB167",

  [theme.breakpoints.down("sm")]: {
    width: 42,
    height: 42,
    minWidth: 42,
    fontSize: 21,
  },
},

mobileAppBannerText: {
  color: "#fff",
},

mobileAppBannerTitle: {
  fontSize: 18,
  fontWeight: 700,
  marginBottom: 3,

  [theme.breakpoints.down("sm")]: {
    fontSize: 15,
  },
},

mobileAppBannerSubtitle: {
  fontSize: 12,
  color: "rgba(255,255,255,0.8)",

  [theme.breakpoints.down("sm")]: {
    fontSize: 10,
  },
},

mobileAppBannerButtons: {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginRight:20,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
},

mobileStoreButton: {
  display: "flex",
  alignItems: "center",
  gap: 7,

  padding: "8px 12px",
  minWidth: 125,

  borderRadius: 8,
  background: "#fff",
  color: "#15254F",

  textDecoration: "none",
  cursor: "pointer",

  transition: "all 0.25s ease",

  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
    textDecoration: "none",
  },

  [theme.breakpoints.down("sm")]: {
    flex: 1,
    justifyContent: "center",
    minWidth: 0,
    padding: "8px 6px",
  },
},

mobileStoreIcon: {
  fontSize: 20,
  fontWeight: 700,
},

mobileStoreText: {
  display: "flex",
  flexDirection: "column",
  lineHeight: 1.1,
},

mobileStoreSmallText: {
  fontSize: 7,
  fontWeight: 500,
},

mobileStoreMainText: {
  fontSize: 12,
  fontWeight: 700,
},

mobileAppClose: {
  position: "absolute",
  top: 6,
  right: 8,

  width: 24,
  height: 24,

  border: "none",
  borderRadius: "50%",

  background: "rgba(255,255,255,0.15)",
  color: "#fff",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  cursor: "pointer",
  fontSize: 18,
  lineHeight: 1,

  "&:hover": {
    background: "rgba(255,255,255,0.3)",
  },
},
}));

export default function Welcome() {
  const classes = useStyles();
  const device = getDeviceType();
  const enableGetTheAppBtn = enableGetTheAppButton && device !=="ios"
  const navigate = useNavigate();
const scrollToEligibility = () => {
  document.getElementById("features-eligibility")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
  const sectionRefs = useRef({});
  const [visibleSections, setVisibleSections] = useState({});
  const [showMobileAppBanner, setShowMobileAppBanner] = useState(true);
  const revealClass = (key) =>
    `${classes.section} ${
      visibleSections[key] ? classes.revealVisible : classes.revealHidden
    }`;
    useEffect(() => {
  const bannerClosed = sessionStorage.getItem("mobileAppBannerClosed");

  if (bannerClosed === "true") {
    setShowMobileAppBanner(false);
  }
}, []);
const closeMobileAppBanner = () => {
  sessionStorage.setItem("mobileAppBannerClosed", "true");
  setShowMobileAppBanner(false);
};
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const key = entry.target.dataset.key;
            setVisibleSections((prev) =>
              prev[key] ? prev : { ...prev, [key]: true }
            );
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "0px 0px -15% 0px",
        threshold: 0.2,
      }
    );

    Object.values(sectionRefs.current).forEach((node) => {
      if (node) observer.observe(node);
    });

    return () => observer.disconnect();
  }, []);

  const [loanAmount, setLoanAmount] = useState(60000);

  const [interestRate, setInterestRate] = useState(24);

  const [tenure, setTenure] = useState(6);

  const { emi, totalAmount, totalInterest } = useMemo(() => {
    const monthlyRate = interestRate / 12 / 100;

    const emiValue =
      (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, tenure)) /
      (Math.pow(1 + monthlyRate, tenure) - 1 || 1);

    const total = emiValue * tenure;

    return {
      emi: Math.round(emiValue),
      totalAmount: Math.round(total),
      totalInterest: Math.round(total - loanAmount),
    };
  }, [loanAmount, interestRate, tenure]);

  const formatCurrency = (num) => new Intl.NumberFormat("en-IN").format(num);

  const purposeIcons = {
    Medical: <LocalHospital />,
    Travel: <Flight />,
    Shopping: <ShoppingCart />,
    Education: <School />,
    Renovation: <Home />,
    Business: <BusinessCenter />,
  };

  return (
    <div className={classes.container}>
      {/* Hero */}

     <div className={classes.heroSection}>
  <Typography className={classes.nbfcTitle}>
    Operated by Aryaman Finance (India) Limited . RBI-Registered NBFC
  </Typography>

  <Typography variant="h3" className={classes.heroTitle}>
    Personal loan up to <Typography className={classes.heroTitle} style={{color:brandTheme?.secondaryColor, padding:0, margin:0}}>₹2,00,000</Typography>
    straight to your bank <Typography className={classes.heroTitle} style={{ padding:0, margin:0}}> account. </Typography>
  </Typography>

  <Typography variant="body1" className={classes.heroSubtitle}>
    Apply in minutes. No branch visits. No paperwork. Disbursed in 5
    minutes by an RBI-registered lender you can trust.
  </Typography>

  <div className={classes.heroButtons}>
    <Button
      className={classes.primaryButton}
      onClick={() =>{
        if(enableGetTheAppBtn){
        window.open(
          "https://play.google.com/store/apps/details?id=com.personalloanapp",
          "_blank",
          "noopener,noreferrer"
        )
      }else{
        navigate("/login")
      }
      }
      }
    >
      {enableGetTheAppBtn ? "Download App" : "Apply Now"}
    </Button>

    <Button
      className={classes.secondaryButton}
      onClick={scrollToEligibility}
    >
      Check Eligibility
    </Button>
  </div>
</div>

          <Box className={classes.zeroForeclosureBanner}>
  <Box className={classes.foreClosureContainer}>
    <Box className={classes.leftIcon}>
      <img
        src={shield}
        alt="Zero Charges Shield"
        className={classes.shieldImage}
      />
    </Box>

    <Box className={classes.content}>
      <Typography className={classes.title}>
        Zero Foreclosure Charges
      </Typography>

      <Typography className={classes.description}>
        Close your loan anytime without any charges.
      </Typography>
    </Box>

    <Box className={classes.rightIcon}>
      <img
        src={piggyBank}
        alt="Piggy"
        className={classes.piggyImage}
      />
    </Box>
  </Box>
</Box>
      {/* Features */}
      <div className={classes.section}>
        <Typography variant="h4" className={classes.sectionTitle}>
          Why Choose
          <span className={classes.subSectionTitle}>GetCred</span>?
        </Typography>

        <Typography className={classes.sectionSubtitle}>
          Modern financial solutions designed for your convenience.
        </Typography>

        <div className={classes.cardGrid}>
          {welcomeWhyChooseUS.map((item, index) => (
            <FeatureCard key={index} item={item} classes={classes} />
          ))}
        </div>
      </div>

      {/* Loan Glance */}
       <div
        // ref={(el) => (sectionRefs.current.applicationRequirements = el)}
        data-key="applicationRequirements"
        // className={revealClass("applicationRequirements")}
      >
        <Typography variant="h4" className={classes.sectionTitle}>
      Loan at Glance
        </Typography>
        <LoanAtAGlance />
      </div>
 {/* EMI Calculator */}
      <div
        // ref={(el) => (sectionRefs.current.emiCalculator = el)}
        data-key="emiCalculator"
        className={classes.section}
        // className={revealClass("emiCalculator")}
      >
        <Typography variant="h4" className={classes.sectionTitle}>
          EMI Calculator
        </Typography>

        <div
          style={{
            display: "flex",
            gap: "30px",
            flexWrap: "wrap",
            alignItems: "stretch",
          }}
        >
          {/* Left */}
          <div
            className={classes.calculatorBox}
            style={{
              flex: 1,
              minWidth: "280px",
            }}
          >
            {/* Loan */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                gap: "14px",
                flexWrap: "wrap",
              }}
            >
              <Typography>Loan Amount</Typography>

              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={loanAmount}
                onChange={(e) => setLoanAmount(Number(e.target.value))}
                style={{
                  width: "100%",
                  maxWidth: "140px",
                }}
              />
            </div>

            <input
              type="range"
              min="50000"
              max="200000"
              step="10000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(Number(e.target.value))}
              className={classes.slider}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                marginBottom: "30px",
                fontWeight: "600",
              }}
            >
              <span>₹50K</span>
              <span>₹2L</span>
            </div>

            {/* Interest */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                gap: "14px",
                flexWrap: "wrap",
              }}
            >
              <Typography>Interest Rate</Typography>

              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={interestRate}
                onChange={(e) => setInterestRate(Number(e.target.value))}
                style={{
                  width: "100%",
                  maxWidth: "140px",
                }}
              />
            </div>

            <input
              type="range"
              min="24"
              max="36"
              step="1"
              value={interestRate}
              onChange={(e) => setInterestRate(Number(e.target.value))}
              className={classes.slider}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                marginBottom: "30px",
                fontWeight: "600",
              }}
            >
              <span>24%</span>
              <span>36%</span>
            </div>

            {/* Tenure */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                gap: "14px",
                flexWrap: "wrap",
              }}
            >
              <Typography>Tenure</Typography>

              <TextField
                type="number"
                variant="outlined"
                size="small"
                value={tenure}
                onChange={(e) => setTenure(Number(e.target.value))}
                style={{
                  width: "100%",
                  maxWidth: "140px",
                }}
              />
            </div>

            <input
              type="range"
              min="2"
              max="60"
              step="3"
              value={tenure}
              onChange={(e) => setTenure(Number(e.target.value))}
              className={classes.slider}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                marginBottom: "30px",
                fontWeight: "600",
              }}
            >
              <span>2 Months</span>
              <span>60 Months</span>
            </div>
          </div>

          {/* Right */}
          <div
            className={classes.calculatorResult}
            style={{
              flex: 1,
              minWidth: "280px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h6"
              style={{
                marginBottom: "10px",
              }}
            >
              Monthly EMI
            </Typography>

            <Typography
              variant="h3"
              style={{
                fontWeight: "bold",
                marginBottom: "30px",
                wordBreak: "break-word",
              }}
            >
              ₹ {formatCurrency(emi)}
            </Typography>

            <Typography>Total Amount</Typography>

            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                marginBottom: "20px",
                wordBreak: "break-word",
              }}
            >
              ₹ {formatCurrency(totalAmount)}
            </Typography>

            <Typography>Total Interest</Typography>

            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                marginBottom: "30px",
                wordBreak: "break-word",
              }}
            >
              ₹ {formatCurrency(totalInterest)}
            </Typography>

            {/* <Button
              className={classes.primaryButton}
              style={{
                width: "100%",
              }}
              onClick={() => navigate("/login")}
            >
              Get Loan Now
            </Button> */}
          </div>
        </div>
      </div>


      {/* Application Requirements */}
      <div
        // ref={(el) => (sectionRefs.current.applicationRequirements = el)}
        data-key="applicationRequirements"
        className={classes.section}
        // className={revealClass("applicationRequirements")}
      >
        <Typography variant="h4" className={classes.sectionTitle}>
          Application Requirements
        </Typography>
        <ApplicationRequirements />
      </div>

      {/* Documents Required */}
      <div
        // ref={(el) => (sectionRefs.current.documentsRequired = el)}
        data-key="documentsRequired"
        className={classes.section}
        // className={revealClass("documentsRequired")}
      >
        <Typography variant="h4" className={classes.sectionTitle}>
          Documents Required
        </Typography>

        <DocumentGrid
          title="Documents Required"
          items={documentItems}
          classes={classes}
        />
      </div>

      {/* Verification & Eligibility */}
      <div
        // ref={(el) => (sectionRefs.current.verificationEligibility = el)}
        data-key="verificationEligibility"
        className={classes.section}
        // className={revealClass("verificationEligibility")}
                id="features-eligibility"
      >
        <Typography variant="h4" className={classes.sectionTitle}>
          Features & Eligibility
        </Typography>

        <div className={classes.featureContainer}>
          <FeatureEligibilityCard
            title="Features"
            items={welcomeFeatures.map((item) => item.title)}
            image="/images/eligible.webp"
            imagePosition="left"
            headerColor={brandTheme.mainColor}
            classes={classes}
          />

          <FeatureEligibilityCard
            title="Eligibility"
            items={welcomeEligibilityList}
            image="/images/feature.jpeg"
            imagePosition="right"
            headerColor={brandTheme.secondaryColor}
            classes={classes}
          />
        </div>
      </div>
      <div
        // ref={(el) => (sectionRefs.current.verificationEligibility = el)}
        data-key="verificationEligibility"
        className={classes.section}
        // className={revealClass("verificationEligibility")}
      >
        <Typography variant="h4" className={classes.sectionTitle}>
          How It Works
        </Typography>

        <div className={classes.howItWorkSection}>
          <HowItWorksSection />
        </div>
      </div>

      {/* Other Fees & Charges */}
      <div
        // ref={(el) => (sectionRefs.current.otherFees = el)}
        data-key="otherFees"
        className={classes.section}
        // className={revealClass("otherFees")}
      >
        <Typography variant="h4" className={classes.sectionTitle}>
          Other Fees & Charges
        </Typography>

        <div>
          <DetailListCard
            title=""
            items={welcomeOtherFeesCharges}
            classes={classes}
          />
        </div>
      </div>


      {/* Purpose */}
      <div
        // ref={(el) => (sectionRefs.current.purpose = el)}
        data-key="purpose"
        className={classes.section}
        // className={revealClass("purpose")}
      >
        <Typography variant="h4" className={classes.sectionTitle}>
          Purpose & Uses
        </Typography>

        <Typography className={classes.sectionSubtitle}>
          Use your personal loan for important life goals.
        </Typography>

        <div className={classes.purposeGrid}>
          {welcomePurposeList.map((item, index) => (
            <div key={index} className={classes.purposeCard}>
              <div className={classes.purposeIcon}>
                {purposeIcons[item.title]}
              </div>
              <Typography className={classes.purposeTitle}>
                {item.title}
              </Typography>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className={classes.helpSection}>
        <img
          src="/images/helpGreeting.png"
          alt="Help Greeting"
          className={classes.helpImage}
        />

        <div className={classes.helpContent}>
          <Typography variant="h4" className={classes.helpTitle}>
            Need Help Getting Credit?
          </Typography>

          <Typography variant="body1" className={classes.helpDescription}>
            Get instant personal loans with minimal documents and fast
            disbursal.
          </Typography>
        </div>

        <Button
          variant="contained"
          color="primary"
          className={classes.applyButton}
          // onClick={() => navigate("/login")}
          onClick={() =>{
                if(enableGetTheAppBtn){
                window.open(
                  "https://play.google.com/store/apps/details?id=com.personalloanapp",
                  "_blank",
                  "noopener,noreferrer"
                )
              }else{
                navigate("/login")
              }
          }
           }
        >
       {enableGetTheAppBtn ? "Download App" : "Apply Now"}
        </Button>
      </div>

      {/* */}
      <Paper className={classes.legalContainer} elevation={0}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <Link href="/privacy-policy" underline="none">
              <div className={classes.legalCard}>
                <div className={classes.iconCircle}>
                  <Security />
                </div>
                <Typography className={classes.linkTitle}>
                  Privacy Policy
                </Typography>
              </div>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Link href="/term-and-conditions" underline="none">
              <div className={classes.legalCard}>
                <div className={classes.iconCircle}>
                  <Description />
                </div>

                <Typography className={classes.linkTitle}>
                  Terms & Conditions
                </Typography>
              </div>
            </Link>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Link href="/contact" underline="none">
              <div
                className={classes.legalCard}
                style={{ borderRight: "none" }}
              >
                <div className={classes.iconCircle}>
                  <ContactSupport />
                </div>

                <Typography className={classes.linkTitle}>
                  Contact Us
                </Typography>
              </div>
            </Link>
          </Grid>
        </Grid>
      </Paper>
      {showMobileAppBanner && (
  <div className={classes.mobileAppBanner}>

    {/* Close */}
    <button
      type="button"
      className={classes.mobileAppClose}
      onClick={closeMobileAppBanner}
      aria-label="Close mobile app banner"
    >
      ×
    </button>

    {/* Content */}
    <div className={classes.mobileAppBannerContent}>

      <div className={classes.mobileAppBannerIcon}>
        📱
      </div>

      <div className={classes.mobileAppBannerText}>
        <Typography className={classes.mobileAppBannerTitle}>
          Get the GetCred Mobile App
        </Typography>

        <Typography className={classes.mobileAppBannerSubtitle}>
          Manage your loans anytime, anywhere.
        </Typography>
      </div>

    </div>

    {/* Store Buttons */}
    <div className={classes.mobileAppBannerButtons}>

      <a
        href="YOUR_GOOGLE_PLAY_STORE_URL"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.mobileStoreButton}
      >
        <span className={classes.mobileStoreIcon}>
          ▶
        </span>

        <span className={classes.mobileStoreText}>
          <span className={classes.mobileStoreSmallText}>
            GET IT ON
          </span>

          <span className={classes.mobileStoreMainText}>
            Google Play
          </span>
        </span>
      </a>

      <a
        href="YOUR_APP_STORE_URL"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.mobileStoreButton}
      >
        <span className={classes.mobileStoreIcon}>
          
        </span>

        <span className={classes.mobileStoreText}>
          <span className={classes.mobileStoreSmallText}>
            DOWNLOAD ON THE
          </span>

          <span className={classes.mobileStoreMainText}>
            App Store
          </span>
        </span>
      </a>

    </div>

  </div>
)}
    </div>
  );
}
